import { DyTableColumn } from 'src/app/dynamic/model/dy-model';

export const TABLE_CONFIG_COLUMNS_USERS: DyTableColumn[] = [
  {
    dataKey: 'actions',
    label: 'Actions',
    width: 50,
    type: 'action',
    actions: [
      {
        name: 'edit',
        iconName: 'pencil',
      },
    ],
    alignClass: 'text-start',
  },
  { dataKey: 'userName', label: 'User Name', width: 200, type: 'text' },
  { dataKey: 'roleName', label: 'User Role', width: 200, type: 'text' },
  { dataKey: 'email', label: 'Email', width: 200, type: 'text' },
];
export const TABLE_CONFIG_COLUMNS_REQUESTED_USERS: DyTableColumn[] = [
  // {
  //   dataKey: 'actions',
  //   label: 'Actions',
  //   width: 100,
  //   type: 'action',
  //   actions: [
  //     {
  //       name: 'edit',
  //       iconName: 'pencil',
  //     },
  //   ],
  //   alignClass: 'text-start',
  // },
  {
      dataKey: 'actions',
      label: 'Actions',
      width: 50,
      type: 'action',
      alignClass: 'text-start',
      actions: [
        {
          name: 'resend',
          iconName: 'resend',
          showHideCondition: 'isResendEnable',
        },
        {
          name: 'delete',
          iconName: 'delete',
          showHideCondition: 'isDeleteEnable',
        },
      ],
    },
  { dataKey: 'userName', label: 'User Name', width: 100, type: 'text' },
  { dataKey: 'roleName', label: 'User Role', width: 100, type: 'text' },
  { dataKey: 'email', label: 'Email', width: 100, type: 'text' },
  { dataKey: 'statusName', label: 'Status', width: 100, type: 'status' },
  
];